import { Component, Output, EventEmitter, OnInit, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { FormsModule, ReactiveFormsModule, FormGroup, ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { Subject, throwError } from 'rxjs';
import { CommonModule } from '@angular/common';

import { CitiesService } from './cities.service';
import { AuthService } from '../../auth.service';
import { LayoutService } from '../../layout.service';

import { City } from '../interfaces/city';
import { User } from '../interfaces/user';
import { CriteriaService } from '../../criteria.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-city-input',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './city-input.component.html',
  styleUrls: ['./city-input.component.scss'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class CityInputComponent implements OnInit, OnDestroy {
  @Input() user!: User | null
  @Input() formGroupName!: string
  @Output() emitCity = new EventEmitter<City | null>() 
  @ViewChild('input') input!: ElementRef

  citiesLoading = false
  noCityFound = false
  childForm!: FormGroup
  cityCtrl!: FormControl
  cityChoice: City[] | null = null
  citySelected!: City
  inputBounds!: DOMRect
  inputWidth!: number
  private readonly _destroyed = new Subject<void>()
  isDesktop = this.layoutService.isDesktop
  showChoiceList = false

  constructor(
    private parentForm: FormGroupDirective,
    private citiesService: CitiesService,
    private authService: AuthService,
    private layoutService: LayoutService,
    private criteriaService: CriteriaService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.childForm = this.parentForm.form
    console.log(this.parentForm.control)
    // initialize form
    this.childForm = this.parentForm.control.get(this.formGroupName) as FormGroup

    this.citySelected = {
      id: this.user?.city?.id || parseInt(this.authService.get('city_id')) || this.authService.genericUserData?.city?.id,
      name: this.user?.city?.name || this.authService.get('city_name') || this.authService.genericUserData?.city?.name,
    }

    if(this.router.url.includes('/my-dating-criteria')){
      this.criteriaService.getCriteria().subscribe(criteria => {
        // pre-fill the city input
        this.childForm.get('cityCtrl')?.patchValue(criteria.city.name || '')
    
        // when input value changes, call to the api to get a city choices list
        this.childForm.get('cityCtrl')?.valueChanges.pipe(
          takeUntil(this._destroyed),
          debounceTime(1000)
        ).subscribe((val) => {
            if(!val?.trim() || (this.citySelected.name && (this.citySelected.name === val))) return
            this.callCities(val)
          })
      })
    } else {
      // pre-fill the city input
      this.childForm.get('cityCtrl')?.patchValue(this.citySelected.name || this.user?.city?.name || '')

      // when input value changes, call to the api to get a city choices list
      this.childForm.get('cityCtrl')?.valueChanges.pipe(
        takeUntil(this._destroyed),
        debounceTime(1000)
      ).subscribe((val: string) => {
        if(!val?.trim() || (this.citySelected.name && (this.citySelected.name === val))) return
        this.callCities(val)
      })
    }

    // open and close the choice list
    this.authService.showChoiceList.subscribe(res => this.showChoiceList = res)
  }

  callCities(value: string | null) {
    this.citiesLoading = true
    this.cityChoice = []

    this.citiesService.getCitiesByName(value?.trim() as string).pipe(takeUntil(this._destroyed)).subscribe({
      next: (res => {
        this.citiesLoading = false

        if(res.length === 0){
          this.noCityFound = true
          return
        }

        this.cityChoice = res
        this.authService.showChoiceList.next(true)

        this.inputBounds = this.input.nativeElement.getBoundingClientRect()
        this.inputWidth = Math.floor(this.inputBounds.right - this.inputBounds.left)

        this.noCityFound = false
      }),
      error: (err => {
        this.citiesLoading = false
        this.noCityFound = true
        return throwError(() => err)
      })
    })
  }
 
  setCity(city?: City){
    if(city){
      this.childForm.get('cityCtrl')?.patchValue(city.name)

      this.emitCity.emit(city)
      this.citySelected = city
    } else {
      this.childForm.get('cityCtrl')?.reset()
      this.noCityFound = false
      this.emitCity.emit(null)
    }

    // close the choice list
    this.cityChoice = null
  }

  ngOnDestroy(){
    this._destroyed.next()
    this._destroyed.complete()
  }
}
